var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content-main"},[_c('div',{staticClass:"ptitle"},[_vm._v("⬇️微信扫码添加课代表")]),_c('img',{staticClass:"qrcode",attrs:{"src":"https://static.huiyiji520.com/qrcode-1766994602.jpg"}})])
}]

export { render, staticRenderFns }